import {
  IonList,
  IonListHeader,
  IonButton,
  IonIcon,
  IonText,
  IonContent,
  IonPopover,
  IonItem,
  IonModal,
} from "@ionic/react";
import { cloudCircleOutline, helpBuoyOutline, pencilOutline, trashOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";
import { RestorePasswordBtn } from "./RestorePasswordBtn";

export const HelperActions: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const status = useSelector(selectDocumentStatus);
  const { id }: { id: string } = useParams();

  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  return (
    <>
      <IonButton onClick={() => setShowModal(true)}>
        <IonIcon icon={helpBuoyOutline} slot="start"></IonIcon>
        <IonText>Ayuda</IonText>
      </IonButton>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <IonText>Acciones</IonText>
            </IonListHeader>
            <IonItem
              routerLink={`/app/rrhh/usuarios/${id}/editar`}
              lines="none"
              onClick={() => {
                // setShowPopover({ showPopover: false, event: undefined });
                setShowModal(false);
              }}
            >
              <IonIcon icon={pencilOutline} />
              <IonText class="ion-padding-start">Editar</IonText>
            </IonItem>
            <RestorePasswordBtn></RestorePasswordBtn>
          </IonList>
        </IonContent>
      </IonModal>

      {/* <IonButton
        id="size-button"
        onClick={(e: any) => {
          e.persist();
          setShowPopover({ showPopover: true, event: e });
        }}
      >
        <IonIcon icon={helpBuoyOutline} slot="start"></IonIcon>
        <IonText>Ayuda</IonText>
      </IonButton>
      <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        <IonContent>
          <IonList>
            <IonListHeader>
              <IonText>Acciones</IonText>
            </IonListHeader>
            <IonItem
              routerLink={`/app/rrhh/usuarios/${id}/editar`}
              lines="none"
              onClick={() => {
                setShowPopover({ showPopover: false, event: undefined });
              }}
            >
              <IonIcon icon={pencilOutline} />
              <IonText class="ion-padding-start">Editar</IonText>
            </IonItem>
            <RestorePasswordBtn></RestorePasswordBtn>
          </IonList>
        </IonContent>
      </IonPopover> */}
    </>
  );
};
